import React, { useEffect, useMemo, useState } from "react";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import { Button, Form, Input, Modal } from "antd";
import { deleteOrganizations } from "../../../redux/SettingModule/OrganizationsPage/OrganizationsPageAction";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

interface DeleteOrganizationsModalProps {
  close: () => void;
  openState: boolean;
  open: () => void;
}

function DeleteOrganizationsModal(props: DeleteOrganizationsModalProps) {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const loading = useSelector((state: RootState) => state.OrganizationsPageState.deleteOrganizationLoading);
  const [error, setError] = React.useState<string>("");

  const currentRecord = useSelector((state: RootState) => state.OrganizationsPageState.currentRecord);
  const [inputValue, setInputValue] = useState("");

  //Modal Close Reseting the Fields
  const handleModalClose = () => {
    props.close();
    form.resetFields();
  };

  useEffect(() => {
    return () => {
      setError("");
      form.resetFields();
      setInputValue("");
    };
  }, [props.openState]);

  const DeleteOrganizationsModalContent = useMemo(() => {
    const onFinish = async (value: any) => {
      try {
        await dispatch(deleteOrganizations(currentRecord.idTenant)).unwrap();
        handleModalClose();
      } catch (error) {
        setError("An error occurred while deleting the organization. Please try again.");
      }
    };
    return (
      <div style={{ width: "100%" }}>
        <h4>Delete Organization</h4>
        <p>
          Please enter <strong>"permanently delete"</strong> to confirm the deletion of tenant:<strong></strong>
        </p>
        <Form
          form={form}
          onFinish={onFinish}
          layout="vertical">
          <Form.Item
            name="confirmation"
            rules={[{ required: true, message: "Please type 'permanently delete' to proceed." }]}>
            <Input
              placeholder="permanently delete"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
          </Form.Item>
          {error && <div className="error justify-content-end align-self-end mb-2">{error}</div>}
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
            <Button
              onClick={handleModalClose}
              loading={loading}>
              Cancel
            </Button>
            <Button
              type="primary"
              danger
              loading={loading}
              htmlType="submit"
              disabled={inputValue !== "permanently delete"}>
              Delete
            </Button>
          </div>
        </Form>
      </div>
    );
  }, [inputValue, loading, error]);

  return (
    <div>
      <Modal
        zIndex={1500}
        footer={[]}
        width={500}
        onCancel={handleModalClose}
        open={props.openState}>
        {DeleteOrganizationsModalContent}
      </Modal>
    </div>
  );
}

export default DeleteOrganizationsModal;
